<template>
<div class="chapter">
<div class="inner_page">
<p class="halftitle" id="halftitle"><a id="pI"></a>Polygamy</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// half_title.vue?00fb5301